import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";

import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import ArticleIcon from "@mui/icons-material/Article";
import {useTranslation} from "react-i18next";

export default function HelpCard() {
  const {t} = useTranslation();
  const listHelperUrl = [
    {
      title: t("home.guides.guidedTour"),
      url: "https://okwind.atlassian.net/servicedesk/customer/portal/1/article/74645560",
      subtitle: false,
    },
    {
      title: t("home.guides.presale"),
      url: "https://okwind.atlassian.net/servicedesk/customer/portal/1/article/76775428",
      subtitle: false,
    },
    {
      title: t("home.guides.implantation"),
      url: "https://okwind.atlassian.net/servicedesk/customer/article/76775557",
      subtitle: true,
    },
    {
      title: t("home.guides.sizing"),
      url: "https://okwind.atlassian.net/servicedesk/customer/portal/1/article/442597412",
      subtitle: true,
    },
    {
      title: t("home.guides.economicStudy"),
      url: "https://okwind.atlassian.net/servicedesk/customer/portal/1/article/440729614",
      subtitle: true,
    },
    {
      title: t("home.guides.fleetManagement"),
      url: "https://okwind.atlassian.net/servicedesk/customer/portal/1/article/76808210",
      subtitle: false,
    },
    {
      title: t("home.guides.clientsAndPlants"),
      url: "https://okwind.atlassian.net/servicedesk/customer/portal/1/article/74580030",
      subtitle: true,
    },
    {
      title: t("home.guides.installationControl"),
      url: "https://okwind.atlassian.net/servicedesk/customer/portal/1/article/74580056",
      subtitle: true,
    },
    {
      title: t("home.guides.scada"),
      url: "https://okwind.atlassian.net/servicedesk/customer/portal/1/article/78446602",
      subtitle: true,
    },
    {
      title: t("home.guides.resources"),
      url: "https://okwind.atlassian.net/servicedesk/customer/portal/1/article/84180996",
      subtitle: false,
    },
    {
      title: t("home.guides.userManagement"),
      url: "https://okwind.atlassian.net/servicedesk/customer/portal/1/article/84115467",
      subtitle: false,
    },
  ];

  return (
    <Card className="custom-card" style={{height: "550px", overflow: "overlay"}} data-testid="helpCard">
      <CardContent>
        <Toolbar style={{marginLeft: "5px", marginTop: "-10px", padding: 0}}>
          <ArticleIcon fontSize="large" style={{marginRight: "10px"}}></ArticleIcon>
          <Typography variant="h5">{t("home.userGuide")}</Typography>
        </Toolbar>
        <List style={{marginTop: "-5px"}}>
          {listHelperUrl.map((element, i) => (
            <ListItem key={i}>
              <ListItemText
                style={{marginTop: "-16px"}}
                disableTypography
                primary={
                  <>
                    <a href={element.url} target="_blank" rel="noreferrer">
                      <Typography
                        style={{
                          fontWeight: "bold",
                          marginLeft: element.subtitle ? "20px" : "0px",
                        }}
                        variant="subtitle1"
                        color="primary">
                        {element.title}
                      </Typography>
                    </a>
                  </>
                }
              />
            </ListItem>
          ))}
        </List>

        <Toolbar style={{marginLeft: "5px", marginTop: "-10px", padding: 0}}>
          <SupportAgentIcon fontSize="large" style={{marginRight: "10px"}}></SupportAgentIcon>
          <Typography variant="h5">{t("home.needHelp")}</Typography>
        </Toolbar>
        <List style={{marginTop: "-5px"}}>
          <ListItem>
            <ListItemText
              style={{marginTop: "-10px"}}
              disableTypography
              primary={<Typography variant="subtitle1">{t("home.keyUserHelp")}</Typography>}
              secondary={
                <>
                  <a
                    href="https://okwind.atlassian.net/servicedesk/customer/portal/1/article/78905367"
                    target="_blank"
                    rel="noreferrer">
                    <Typography style={{fontWeight: "bold"}} variant="subtitle1" color="primary">
                      {t("home.findKeyUser")}
                    </Typography>
                  </a>
                </>
              }
            />
          </ListItem>
        </List>
      </CardContent>
    </Card>
  );
}
